import MdxContent from "../../help/inspection-record-create.mdx";

export function InspectionRecordCreatePageHelpPage() {
  return <MdxContent />;
}
